// Shared by the homepage widget and the guest form. Matches the API's INR limits.
export const MAX_INDICATIVE_AMOUNT = 10000000000;

export function validateIndicativeAmount(input) {
  const raw = typeof input === 'string' ? input.trim() : '';
  if (!raw) return {value: '', error: 'required'};
  if (raw.length > 24 || !/^(?:\d+(?:\.\d{1,2})?|\.\d{1,2})$/.test(raw)) {
    return {value: '', error: 'format'};
  }
  const [whole, fraction] = raw.split('.');
  const integer = Number(whole || '0');
  const minor = integer * 100 + Number((fraction || '').padEnd(2, '0'));
  if (!Number.isSafeInteger(minor) || minor < 1 || minor > MAX_INDICATIVE_AMOUNT * 100) {
    return {value: '', error: 'range'};
  }
  // Avoid floating-point rounding; preserve the entered decimal precision.
  return {value: `${integer}${fraction !== undefined ? `.${fraction}` : ''}`, error: ''};
}

export const amountErrors = {
  required: 'Enter an indicative amount to continue.',
  format: 'Enter an amount using numbers and up to two decimal places.',
  range: 'Enter a positive amount within the supported range. Contact investor relations for larger indications.',
};

export function readAmountPrefill(params) {
  const values = params.getAll('amount');
  if (!values.length) return {value: '', status: ''};
  if (values.length !== 1) return {value: '', status: 'invalid'};
  const result = validateIndicativeAmount(values[0]);
  return {value: result.value, status: result.error ? 'invalid' : 'valid'};
}